export const toQueryString = (queryObject: Record<string, string>) =>
  Object.keys(queryObject)
    .map(key => `${key}=${encodeURIComponent(queryObject[key])}`)
    .join('&');
